var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.04 7.32L14.28 3.29C12.71 2.19 10.3 2.25 8.79 3.42L3.78 7.33C2.78 8.11 1.99 9.71 1.99 10.97V17.87C1.99 20.42 4.06 22.5 6.61 22.5H17.39C19.94 22.5 22.01 20.43 22.01 17.88V11.1C22.01 9.75 21.14 8.09 20.04 7.32ZM12.75 18.5C12.75 18.91 12.41 19.25 12 19.25C11.59 19.25 11.25 18.91 11.25 18.5V15.5C11.25 15.09 11.59 14.75 12 14.75C12.41 14.75 12.75 15.09 12.75 15.5V18.5Z",
    fill: "#B2DDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaces);
export default __webpack_public_path__ + "static/media/Places.c960a073ca20921a654fa3ed2bf10af8.svg";
export { ForwardRef as ReactComponent };